// Google tag (gtag.js) — Google Analytics 4 + Google Ads, só no fluxo de cadastro.
//
// REACT_APP_GA_MEASUREMENT_ID: ID do GA4 (G-...). Mesmo ID do site institucional,
// para o cadastro aparecer no mesmo funil. O evento `sign_up` é importado como
// conversão no Google Ads.
// REACT_APP_GOOGLE_ADS_ID / REACT_APP_GOOGLE_ADS_CONVERSION_LABEL: conversão
// nativa do Google Ads (opcional). Se usar as duas, marque só uma como
// "Principal" no Google Ads para não contar o cadastro duas vezes.
//
// Sem nenhum ID definido (dev/local) tudo aqui é no-op.
//
// A tag NÃO deve ser carregada nas telas internas: como o app é SPA, ela
// continuaria ativa ao navegar. Por isso só o Signup chama initAnalytics() e,
// após o cadastro, o redirect para /login recarrega a página (descarta a tag).
//
// Nunca envie dados pessoais (e-mail, nome, telefone, CPF/CNPJ, IDs) nos eventos.

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
const GOOGLE_ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;
const GOOGLE_ADS_CONVERSION_LABEL = process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL;

const SCRIPT_ID = "google-gtag";
// Tempo máximo esperando o envio do evento antes de seguir (ex.: redirect).
const EVENT_TIMEOUT_MS = 1000;

const tagIds = [GA_MEASUREMENT_ID, GOOGLE_ADS_ID].filter(Boolean);

export const initAnalytics = () => {
	if (!tagIds.length || document.getElementById(SCRIPT_ID)) {
		return;
	}

	const script = document.createElement("script");
	script.id = SCRIPT_ID;
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtag/js?id=${tagIds[0]}`;
	document.head.appendChild(script);

	window.dataLayer = window.dataLayer || [];
	window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
	window.gtag("js", new Date());
	tagIds.forEach((id) => window.gtag("config", id));
};

// Envia um evento e resolve quando o gtag confirma o envio ou após o timeout
// de segurança (gtag bloqueado por adblock, rede lenta etc.). Nunca rejeita.
export const trackEvent = (name, params = {}) =>
	new Promise((resolve) => {
		if (typeof window.gtag !== "function") {
			resolve();
			return;
		}

		let done = false;
		const finish = () => {
			if (!done) {
				done = true;
				resolve();
			}
		};

		setTimeout(finish, EVENT_TIMEOUT_MS);
		window.gtag("event", name, {
			...params,
			transport_type: "beacon",
			event_callback: finish,
		});
	});

// Cadastro concluído: evento `sign_up` do GA4 + conversão nativa do Google Ads
// (esta só se o label estiver configurado).
export const trackSignUp = () => {
	const events = [];

	if (GA_MEASUREMENT_ID) {
		events.push(trackEvent("sign_up", { method: "email", send_to: GA_MEASUREMENT_ID }));
	}

	if (GOOGLE_ADS_ID && GOOGLE_ADS_CONVERSION_LABEL) {
		events.push(trackEvent("conversion", { send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_CONVERSION_LABEL}` }));
	}

	return Promise.all(events);
};
